import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';

export const CloseContainerIconStyled = styled(FontAwesomeIcon)(
  ({ theme }) => ({
    fontSize: '14px',
    color: theme.palette.colors.onSecondaryAndDetailBackground,
    cursor: 'pointer',
  }),
);
